<template>
  <a
    href="https://www.ucari.com/discount/WELLNESS20?redirect=/collections/all"
    target="_blank"
    rel="noopener noreferrer"
    class="wellness-promo"
  >
    <img src="/images/promo-wellness-20.png" alt="Wellness 20 promo">
  </a>
</template>

<script>
export default {
  name: 'WellnessJourneyPromo'
};
</script>

<style scoped>
.wellness-promo {
  display: block;
  width: 90%;
  margin-left: auto;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(15, 38, 95, 0.08);
}

.wellness-promo img {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-width: 639px) {
  .wellness-promo {
    width: 100%;
    margin-left: 0;
    border-radius: 16px;
  }
}
</style>